import { backendApi } from "@api/base/backend";

export async function fetchActivatedUsers() {
  const data = await backendApi.callApi(
    "/admin/users",
    "GET"
  );

  return { data };
}

export async function fetchWhitelistUsers() {
  const data = await backendApi.callApi(
    "/admin/users/whitelist",
    "GET"
  );

  return { data };
}

export async function whitelistUser(
  username: string,
  phoneNumber: string,
  expiry: number,
) {
  const data = await backendApi.callApi(
    "/admin/whitelist",
    "POST",
    JSON.stringify({
      username,
      phone_number: phoneNumber,
      expiry,
    })
  );

  return { data };
}

export async function cancelWhitelistInvite(
  username: string,
  phoneNumber: string,
) {
  const data = await backendApi.callApi(
    "/admin/whitelist",
    "DELETE",
    JSON.stringify({
      username,
      phone_number: phoneNumber,
    })
  );

  return { data };
}

export async function addWhitelistExpiry(
  username: string,
  phoneNumber: string,
  expiry: number,
) {
  const data = await backendApi.callApi(
    "/admin/whitelist",
    "PATCH",
    JSON.stringify({
      username,
      phone_number: phoneNumber,
      expiry,
    })
  );

  return { data };
}

export async function forceLogOutUser(
  username: string,
) {
  const data = await backendApi.callApi(
    "/admin/users/logout",
    "POST",
    JSON.stringify({
      username,
    })
  );

  return { data };
}

